// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LessonCard_wrapper_3A4dT","image":"LessonCard_image_1wwcg","title":"LessonCard_title_3XTM6","locked":"LessonCard_locked_2KShR"};